import { Component, OnInit } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import EMAIL_REGEX from '../../validators/regex/email.regex';
import {NotificationService} from '../../services/notification.service';
import {ContactService} from '../../services/contact.service';

@Component({
  templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit {

  form;
  submitted = false;

  constructor(
    private builder: FormBuilder,
    private notificationService: NotificationService,
    private contactService: ContactService
  ) { }

  ngOnInit() {
    this.form = this.getCleanForm();
  }

  private getCleanForm() {
    return this.builder.group({
      'name': ['', [Validators.required, Validators.minLength(2)]],
      'mail': ['', [Validators.required,  Validators.pattern(EMAIL_REGEX)]],
      'phone': [''],
      'question': ['', [Validators.required, Validators.minLength(2)]],
    });
  }

  save(value) {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.contactService.contact(value).subscribe(() => {
      this.form = this.getCleanForm();
      this.submitted = false;
      this.notificationService.success('hartelijk dank voor uw bericht.');
    }, () => {
      this.submitted = false;
      this.notificationService.error('er is iets misgegaan, probeer het later opnieuw.');
    });
  }

  get f() { return this.form.controls; }

}
